/* eslint-disable sonarjs/no-duplicate-string */
const countryMap: { [key: string]: string } = {
    AUS: "Australia",
    AUT: "Austria",
    BEL: "Belgium",
    CAN: "Canada",
    CHE: "Switzerland",
    DEU: "Germany",
    DNK: "Denmark",
    ESP: "Spain",
    FIN: "Finland",
    FRA: "France",
    GBR: "United Kingdom",
    GRC: "Greece",
    IRL: "Ireland",
    ISL: "Iceland",
    ITA: "Italy",
    JPN: "Japan",
    LUX: "Luxembourg",
    NLD: "Netherlands",
    NOR: "Norway",
    NZL: "New Zealand",
    PRT: "Portugal",
    SWE: "Sweden",
    USA: "United States",
    // New Countries since 2025
    LVA: "Latvia",
    TUR: "Turkey",
    EST: "Estonia",
    HUN: "Hungary",
    LTU: "Lithuania",
    KOR: "South Korea",
    SVN: "Slovenia",
    SVK: "Slovak Republic",
    ISR: "Israel",
    CZE: "Czech Republic",
    POL: "Poland",
    // EM Countries
    CYP: "Cyprus",
    KEN: "Kenya",
    URY: "Uruguay",
    CHL: "Chile",
    HKG: "Hong Kong",
    PER: "Peru",
    SLV: "El Salvador",
    CRI: "Costa Rica",
    JOR: "Jordan",
    PHL: "Philippines",
    BGD: "Bangladesh",
    ECU: "Ecuador",
    SRB: "Serbia",
    AZE: "Azerbaijan",
    PAN: "Panama",
    KWT: "Kuwait",
    ROU: "Romania",
    UGA: "Uganda",
    GHA: "Ghana",
    LKA: "Sri Lanka",
    THA: "Thailand",
    DOM: "Dominican Republic",
    COL: "Colombia",
    VNM: "Vietnam",
    HRV: "Croatia",
    BRA: "Brazil",
    MAR: "Morocco",
    BGR: "Bulgaria",
    PAK: "Pakistan",
    ZAF: "South Africa",
    MLT: "Malta",
    JAM: "Jamaica",
    BHR: "Bahrain",
    IDN: "Indonesia",
    SGP: "Singapore",
    ARG: "Argentina",
    IND: "India",
    AGO: "Angola",
    MEX: "Mexico",
    UKR: "Ukraine",
    NGA: "Nigeria",
    EGY: "Egypt",
    OMN: "Oman",
    RUS: "Russia",
    CHN: "China",
    KAZ: "Kazakhstan",
    ARE: "United Arab Emirates",
    PRY: "Paraguay",
    MYS: "Malaysia",
    SAU: "Saudi Arabia",
    QAT: "Qatar",
};
export const ANNEX_2_COUNTRIES = [
    "Australia",
    "Austria",
    "Belgium",
    "Canada",
    "Denmark",
    "Finland",
    "France",
    "Germany",
    "Greece",
    "Iceland",
    "Ireland",
    "Italy",
    "Japan",
    "Luxembourg",
    "Netherlands",
    "New Zealand",
    "Norway",
    "Portugal",
    "Spain",
    "Sweden",
    "Switzerland",
    "United Kingdom",
    "United States",
];

export const OECD_COUNTRIES = [
    "Australia",
    "Austria",
    "Belgium",
    "Canada",
    "Chile",
    "Colombia",
    "Czech Republic",
    "Denmark",
    "Estonia",
    "Finland",
    "France",
    "Germany",
    "Greece",
    "Hungary",
    "Iceland",
    "Ireland",
    "Israel",
    "Italy",
    "Japan",
    "South Korea",
    "Latvia",
    "Lithuania",
    "Luxembourg",
    "Mexico",
    "Netherlands",
    "New Zealand",
    "Norway",
    "Poland",
    "Portugal",
    "Slovak Republic",
    "Slovenia",
    "Spain",
    "Sweden",
    "Switzerland",
    "Turkey",
    "United Kingdom",
    "United States",
];

export const EM_COUNTRIES = [
    "Cyprus",
    "Kenya",
    "Uruguay",
    "Chile",
    "Hong Kong",
    "Peru",
    "El Salvador",
    "Costa Rica",
    "Jordan",
    "Philippines",
    "Bangladesh",
    "Ecuador",
    "Serbia",
    "Azerbaijan",
    "Panama",
    "Kuwait",
    "Romania",
    "Uganda",
    "Ghana",
    "Sri Lanka",
    "Thailand",
    "Dominican Republic",
    "Colombia",
    "Vietnam",
    "Croatia",
    "Brazil",
    "Morocco",
    "Bulgaria",
    "Pakistan",
    "South Africa",
    "Malta",
    "Jamaica",
    "Bahrain",
    "Indonesia",
    "Singapore",
    "Argentina",
    "India",
    "Angola",
    "Mexico",
    "Ukraine",
    "Nigeria",
    "Egypt",
    "Oman",
    "Russia",
    "China",
    "Kazakhstan",
    "United Arab Emirates",
    "Paraguay",
    "Malaysia",
    "Saudi Arabia",
    "Qatar",
];

export const COP_7_COUNTRIES = [
    "Canada",
    "France",
    "Germany",
    "Italy",
    "Japan",
    "United Kingdom",
    "United States",
];

export const EMERGING_COUNTRIES = [
    "Brazil",
    "Russia",
    "India",
    "China",
    "South Africa",
    "Mexico",
    "Indonesia",
    "Turkey",
    "Saudi Arabia",
    "Argentina",
];

export const EU_COUNTRIES = [
    "Austria",
    "Belgium",
    "Bulgaria",
    "Croatia",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Estonia",
    "Finland",
    "France",
    "Germany",
    "Greece",
    "Hungary",
    "Ireland",
    "Italy",
    "Latvia",
    "Lithuania",
    "Luxembourg",
    "Malta",
    "Netherlands",
    "Poland",
    "Portugal",
    "Romania",
    "Slovak Republic",
    "Slovenia",
    "Spain",
    "Sweden",
];

export function countryKeyToName(key: string): string {
    return countryMap[key] || key;
}
